import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '@/components/sections/Hero';
import Pricing from '@/components/sections/Pricing';
import WhyUs from '@/components/sections/WhyUs';
import SocialProof from '@/components/sections/SocialProof';
import Process from '@/components/sections/Process';
import FAQ from '@/components/sections/FAQ';
import FinalCTA from '@/components/sections/FinalCTA';
import { HOME_FAQS } from '@/lib/home-faq';
import { SITE_URL } from '@/lib/site';
import { useHomeAnchor } from '@/hooks/useHomeAnchor';
import '@/styles/home.css';

const setMeta = (name, content, property = false) => {
  const attribute = property ? 'property' : 'name';
  let el = document.querySelector(`meta[${attribute}="${name}"]`);
  if (!el) { el = document.createElement('meta'); el.setAttribute(attribute, name); document.head.appendChild(el); }
  el.setAttribute('content', content);
};

export const HomePage = () => {
  const { hash } = useLocation();
  useHomeAnchor(hash);
  useEffect(() => {
    const title = 'Pemasangan CCTV Hikvision dari RM1,800 | Goguard KL & Selangor';
    const description = 'Pemasangan CCTV Hikvision dari RM1,800. Kamera, NVR dan setup app siap guna. Site visit percuma di Lembah Klang. Bayaran 50/50, waranti workmanship 12 bulan.';
    document.title = title;
    setMeta('title', title);
    setMeta('description', description);
    setMeta('og:title', title, true);
    setMeta('og:description', description, true);
    setMeta('og:url', `${SITE_URL}/`, true);
    setMeta('og:type', 'website', true);
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', `${SITE_URL}/`);
    const schema = document.createElement('script');
    schema.id = 'faq-schema-jsonld';
    schema.type = 'application/ld+json';
    schema.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: HOME_FAQS.map(({ q, a }) => ({ '@type': 'Question', name: q, acceptedAnswer: { '@type': 'Answer', text: a } })) });
    document.getElementById(schema.id)?.remove();
    document.head.appendChild(schema);
    return () => schema.remove();
  }, []);
  return <div className="gg-home" data-testid="home-page"><Hero /><Pricing /><WhyUs /><SocialProof /><Process /><FAQ /><FinalCTA /></div>;
};

export default HomePage;